import { keyframes } from '@emotion/react';
import type { LoaderProps } from '@hover/blueprint';
import { Loader } from '@hover/blueprint';
import React from 'react';

const fadeAnimation = keyframes`
 0% { opacity: 0; }
 100% { opacity: 1; }
`;

interface DelayedLoaderProps extends LoaderProps {
  delay?: number;
}

const DelayedLoader: React.FC<DelayedLoaderProps> = ({
  delay = 0,
  ...props
}) => (
  <Loader
    opacity={0}
    size="huge"
    sx={{
      animation: `${fadeAnimation} forwards 0s`,
      animationDelay: `${delay}ms`,
    }}
    {...props}
  />
);

export { DelayedLoader };
